// extracted by mini-css-extract-plugin
module.exports = {"alarm":"alarm_alarm__3DA0T","alarm-news":"alarm_alarm-news__2URCi","alarm-error":"alarm_alarm-error__3tHb2","appear":"alarm_appear__3W-qh"};